import React from "react";
import { getClassNameFactory } from "../../../../../../utilities/classNames/";

var TabList = function TabList(_ref) {
  var children = _ref.children;
  var getClassName = getClassNameFactory(TabList.displayName);
  return /*#__PURE__*/React.createElement("div", {
    role: "presentation"
  }, /*#__PURE__*/React.createElement("ul", {
    role: "tablist",
    className: getClassName({
      descendantName: "list"
    })
  }, children));
};

TabList.displayName = "SiteHeader.Flyouts.TabList";
export default TabList;